const wrapLocalLoader = (
  func: (value?: any) => Promise<any>,
  callback: (value: any) => void
) => {
  return async () => {
    callback(true);

    try {
      await func();

      callback(false);
    } catch (error) {
      callback(false);
    }
  };
};

export default wrapLocalLoader;
